import { ActionType, createAsyncAction } from "typesafe-actions";

import { Route } from "@mapmycustomers/shared/types/entity";
import { PreviewRoutePayload, RoutePreview } from "@mapmycustomers/shared/types/entity/Route";

export const deleteRoute = createAsyncAction(
  "@routes/deleteRoute/request",
  "@routes/deleteRoute/success",
  "@routes/deleteRoute/failure"
)<{ callback: () => void; routeId: Route["id"] }, void, unknown>();

export const duplicateRoute = createAsyncAction(
  "@routes/duplicateRoute/request",
  "@routes/duplicateRoute/success",
  "@routes/duplicateRoute/failure"
)<{ callback: () => void; routeId: Route["id"] }, void, unknown>();

export const fetchRoutes = createAsyncAction(
  "@routes/fetchRoutes/request",
  "@routes/fetchRoutes/success",
  "@routes/fetchRoutes/failure"
)<{ query?: string; selectedRouteIds?: Route["id"][] } | undefined, Route[], void>();

export const fetchRoute = createAsyncAction(
  "@routes/fetchRoute/request",
  "@routes/fetchRoute/success",
  "@routes/fetchRoute/failure"
)<
  {
    callback: (route: Route) => void;
    id: Route["id"];
  },
  void,
  void
>();

export const fetchRoutePreview = createAsyncAction(
  "@routes/fetchRoutePreview/request",
  "@routes/fetchRoutePreview/success",
  "@routes/fetchRoutePreview/failure"
)<
  {
    callback?: (route: RoutePreview) => void;
    failureCallback?: () => void;
    payload: PreviewRoutePayload;
  },
  void,
  void
>();

export type Actions = ActionType<
  | typeof deleteRoute
  | typeof duplicateRoute
  | typeof fetchRoute
  | typeof fetchRoutePreview
  | typeof fetchRoutes
>;
